import script from "./payCommons.vue?vue&type=script&lang=js"
export * from "./payCommons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__